"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOfficeInfoToReplyBar = void 0;
var OfficesInfo_1 = require("@/pages/common/states/OfficesInfo");
exports.transformOfficeInfoToReplyBar = function (officesInfo) {
    var office = officesInfo.offices[0];
    var messages = office.messageContainer.messages;
    var title = messages.length ? messages[0].messageText : '';
    var caption = messages.length ? messages[1].messageText : '';
    var captionLg = '';
    var from = -1;
    var whatsapp = office.commMedias.find(function (it) { return it.mediaType === OfficesInfo_1.OfficeMediaType.WHATSAPP; });
    var phone = office.commMedias.find(function (it) { return it.mediaType === OfficesInfo_1.OfficeMediaType.PHONE; });
    return {
        title: title,
        caption: caption,
        captionLg: captionLg,
        from: from,
        isShow: office.status === OfficesInfo_1.OfficeObjectStatus.ON,
        whatsapp: {
            isShow: whatsapp.status === OfficesInfo_1.OfficeObjectStatus.ON,
            value: whatsapp.mediaData,
        },
        phone: {
            isShow: phone.status === OfficesInfo_1.OfficeObjectStatus.ON,
            value: phone.mediaData,
        },
        callPopup: {
            active: false,
            callUsAt: '',
            callNumber: '',
            callPopupTitle: '',
            officeHours: [],
        }
    };
};
